import { SVGProps } from 'react'

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.6665 7.49984H13.3332M13.3332 7.49984L7.49984 1.6665M13.3332 7.49984L7.49984 13.3332"
      stroke="#0074DD"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
